// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__YQ74k","content":"styles_content__3tBsG","selectAll":"styles_selectAll__3uooJ"};